import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { COMING_SOON, FIELD_REQUIRED } from "../../../../i18n/keysTranslations";
import {
  GOOGLE,
  IDS_PLATFORM_BUTTONS,
  LINKEDIN,
  META,
  PLATFORMS_SUPPORTED_WITH_COMING_SOON,
  TIKTOK,
} from "../../../../utils/constants";
import { INPUT_COLOR_BORDER } from "../../../../utils/colors";
import ButtonMetaAction from "../../../Buttons/ButtonMetaAction";
import ButtonGoogleAction from "../../../Buttons/ButtonGoogleAction";
import ButtonLinkedinAction from "../../../Buttons/ButtonLinkedinAction";
import ButtonTikTokBusinessAction from "../../../Buttons/ButtonTikTokBusinessAction";
import { useTranslationApp } from "../../../../lib/i18next";
import { CREATE_CAMPAIGN_SECTION_HELPER_SX } from "../createAdsCampaignWizardConstants";

const getConfigurationPlatform = (platform) => {
  switch (platform) {
    case META:
      return {
        id: IDS_PLATFORM_BUTTONS[platform],
        container: <ButtonMetaAction />,
      };
    case TIKTOK:
      return {
        id: IDS_PLATFORM_BUTTONS[platform],
        container: <ButtonTikTokBusinessAction />,
      };
    case GOOGLE:
      return {
        id: IDS_PLATFORM_BUTTONS[platform],
        container: <ButtonGoogleAction />,
      };
    case LINKEDIN:
      return {
        id: IDS_PLATFORM_BUTTONS[platform],
        container: <ButtonLinkedinAction />,
      };
    default: {
      const _exhaustive = platform;
      void _exhaustive;
      return null;
    }
  }
};

const StepPlatform = ({ disabled = false, onSelectPlatform = () => {} }) => {
  const { t } = useTranslationApp();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Box sx={{ width: "100%" }}>
      <Controller
        name="platforms"
        control={control}
        rules={{
          required: {
            value: true,
            message: t(FIELD_REQUIRED),
          },
        }}
        render={({ field }) => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              width: "100%",
            }}
          >
            {PLATFORMS_SUPPORTED_WITH_COMING_SOON.map((platform) => {
              const configurationPlatform = getConfigurationPlatform(platform);
              if (!configurationPlatform) return null;

              const isSelected = field.value?.includes(platform);

              return (
                <Box
                  sx={{
                    width: "100%",
                  }}
                  key={platform}
                >
                  {React.cloneElement(configurationPlatform.container, {
                    id: configurationPlatform.id,
                    text: t(platform),
                    logo: platform === META ? META : undefined,
                    doTranslation: false,
                    onClick: () => onSelectPlatform(platform),
                    disabled,
                    selected: isSelected,
                    sx: {
                      color: "black",
                      borderRadius: 3,
                      backgroundColor: "transparent",
                      border: `1px solid ${INPUT_COLOR_BORDER}`,
                      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                      width: "100%",
                      justifyContent: "center",
                      "&:hover": {
                        backgroundColor: isSelected
                          ? `white !important`
                          : "oklch(.95 0 0)",
                        color: `black !important`,
                      },
                      background: "unset",
                    },
                  })}
                  {configurationPlatform.isComingSoon && (
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 0.5,
                        color: "GrayText",
                        fontStyle: "italic",
                        ...CREATE_CAMPAIGN_SECTION_HELPER_SX,
                      }}
                    >
                      {t(COMING_SOON)}
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        )}
      />
      {errors.platforms && (
        <Typography
          variant="body2"
          color="error"
          sx={CREATE_CAMPAIGN_SECTION_HELPER_SX}
        >
          {errors.platforms.message}
        </Typography>
      )}
    </Box>
  );
};

export default StepPlatform;
